/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Booking Status Badge component
 *
 * @param {Object} props
 * @param {string} props.status The booking status.
 * @param {string} props.size   The badge size (sm, md, lg).
 * @return {JSX.Element} The BookingStatusBadge component.
 */
const BookingStatusBadge = ( { status, size = 'md' } ) => {
	const getStatusConfig = ( status ) => {
		const configs = {
			pending: {
				label: __( 'Pending', 'nemtly-booking' ),
				className:
					'nb-bg-yellow-100 nb-text-yellow-800 nb-border-yellow-200',
			},
			confirmed: {
				label: __( 'Confirmed', 'nemtly-booking' ),
				className:
					'nb-bg-green-100 nb-text-green-800 nb-border-green-200',
			},
			cancelled: {
				label: __( 'Cancelled', 'nemtly-booking' ),
				className: 'nb-bg-red-100 nb-text-red-800 nb-border-red-200',
			},
			completed: {
				label: __( 'Completed', 'nemtly-booking' ),
				className: 'nb-bg-blue-100 nb-text-blue-800 nb-border-blue-200',
			},
		};

		return (
			configs[ status ] || {
				label: status,
				className: 'nb-bg-gray-100 nb-text-gray-800 nb-border-gray-200',
			}
		);
	};

	const getSizeClasses = ( size ) => {
		const sizeClasses = {
			sm: 'nb-px-2 nb-py-1 nb-text-xs',
			md: 'nb-px-3 nb-py-1 nb-text-sm',
			lg: 'nb-px-4 nb-py-2 nb-text-base',
		};

		return sizeClasses[ size ] || sizeClasses.md;
	};

	const config = getStatusConfig( status );
	const sizeClasses = getSizeClasses( size );

	return (
		<span
			className={ `nb-inline-flex nb-items-center nb-rounded-full nb-border nb-font-medium ${ config.className } ${ sizeClasses }` }
		>
			{ config.label }
		</span>
	);
};

export default BookingStatusBadge;
